module.exports = {"confirm_delete":"Confirm Delete","create":"Create","save":"Save","update":"Update"};


//////////////////
// WEBPACK FOOTER
// ./resources/lang/en/ui.php
// module id = EtPd
// module chunks = 86